import { Injectable } from '@angular/core';
import { isNil, Nillable } from '@web/utils';
import { TableCollectionAction } from '../models/table-collection-action';
import { TableRowsSelection } from '../models/table-rows-selection';

@Injectable({
  providedIn: 'root',
})
export class OnlyVisibleTableCollectionActionsService<
  Item,
  Filter,
  CollectionAction,
> {
  public resolveVisibility(
    actions: Nillable<
      Array<TableCollectionAction<Item, Filter, CollectionAction>>
    >,
    selection: Nillable<TableRowsSelection<Item, Filter>>,
  ): Nillable<Array<TableCollectionAction<Item, Filter, CollectionAction>>> {
    if (isNil(actions)) {
      return actions;
    }

    return actions.filter((action) => action.visibility(selection));
  }
}
